<h1>Distanzgrafik</h1>

<svg #svgwrapper width="100%" xmlns="http://www.w3.org/2000/svg" class="svg-wrapper">
  <svg app-key-graphic [results]="motiveScores"></svg>
</svg>
